import '@fontsource-variable/source-sans-3'
import '@rgrd/component-library/style.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { setRegardWindowValue } from '~/shared/window'

import { App } from './App'
import { Auth0ProviderWithConfig } from './auth/Auth0ProviderWithConfig'
import { type RuntimeConfig, setRuntimeConfig } from './config'
import './index.css'
import { initializeAmplitude } from './integrations/amplitude'
import { initializeDatadog } from './integrations/datadog'

// Build version, injected as an environment variable during bundling (see the
// Dockerfile's VITE_APP_VERSION). Exposed on window for traceability in deployed images.
setRegardWindowValue('version', import.meta.env.VITE_APP_VERSION)

async function loadConfig(): Promise<RuntimeConfig> {
  const resp = await fetch('/config.json')
  if (!resp.ok) {
    throw new Error(`Failed to load config.json: ${resp.status}`)
  }
  return resp.json()
}

async function main() {
  const config = await loadConfig()
  setRuntimeConfig(config)

  // Initialize Datadog RUM before render so the earliest errors are captured.
  // No-ops unless the runtime config carries both RUM tokens.
  initializeDatadog()

  initializeAmplitude()

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Auth0ProviderWithConfig>
        <App />
      </Auth0ProviderWithConfig>
    </StrictMode>,
  )
}

main()
